import { Component } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/** FAQ accordion. Questions/answers live in i18n under landing.faq.items. */
@Component({
  selector: 'app-landing-faq',
  standalone: true,
  imports: [NgForOf, NgIf, TranslateModule],
  templateUrl: './landing-faq.component.html',
  styleUrls: ['./landing-faq.component.scss'],
})
export class LandingFaqComponent {
  readonly keys = ['what', 'ausbildung_fachkraft', 'language', 'recognition', 'cost', 'duration'];

  openIndex = 0;

  toggle(i: number): void {
    this.openIndex = this.openIndex === i ? -1 : i;
  }
}
